var map = {
	"./de/common.json": [
		77221,
		77221
	],
	"./de/converter.json": [
		36804,
		36804
	],
	"./de/downloadHelpArticleModal.json": [
		72966,
		72966
	],
	"./de/fileTypes.json": [
		72364,
		72364
	],
	"./de/footer.json": [
		95509,
		95509
	],
	"./de/freeTrialModal.json": [
		74959,
		74959
	],
	"./de/inquiryForm.json": [
		14737,
		14737
	],
	"./de/landingPage.json": [
		67590,
		67590
	],
	"./de/navigation.json": [
		84107,
		84107
	],
	"./de/page/AIToFigma.json": [
		57082,
		38588
	],
	"./de/page/AIToSketch.json": [
		2066,
		2066
	],
	"./de/page/CanvaToFigma.json": [
		55304,
		55304
	],
	"./de/page/EPSToFigma.json": [
		10145,
		10145
	],
	"./de/page/FigmaToAI.json": [
		54338,
		54338
	],
	"./de/page/FigmaToBubble.json": [
		90043,
		90043
	],
	"./de/page/FigmaToCanva.json": [
		16895,
		16895
	],
	"./de/page/FigmaToGoogleSlides.json": [
		77499,
		77499
	],
	"./de/page/FigmaToPSD.json": [
		95135,
		95135
	],
	"./de/page/FigmaToPowerpoint.json": [
		52753,
		52753
	],
	"./de/page/FigmaToSketch.json": [
		48556,
		48556
	],
	"./de/page/FigmaToWebflow.json": [
		46179,
		46179
	],
	"./de/page/FigmaToXD.json": [
		4736,
		4736
	],
	"./de/page/GoogleSlidesToFigma.json": [
		23466,
		23466
	],
	"./de/page/IndesignToFigma.json": [
		31602,
		31602
	],
	"./de/page/MiroToFigjam.json": [
		82837,
		82837
	],
	"./de/page/PDFToAI.json": [
		89946,
		89946
	],
	"./de/page/PDFToFigma.json": [
		67761,
		67761
	],
	"./de/page/PDFToPSD.json": [
		13852,
		13852
	],
	"./de/page/PDFToSketch.json": [
		267,
		267
	],
	"./de/page/PDFToXD.json": [
		90782,
		90782
	],
	"./de/page/PSDToFigma.json": [
		59275,
		59275
	],
	"./de/page/PSDToSketch.json": [
		42162,
		42162
	],
	"./de/page/PowerPointToFigma.json": [
		37495,
		37495
	],
	"./de/page/PowerPointToXd.json": [
		17221,
		17221
	],
	"./de/page/SketchToAI.json": [
		17129,
		17129
	],
	"./de/page/SketchToFigma.json": [
		56720,
		56720
	],
	"./de/page/SketchToPSD.json": [
		50489,
		50489
	],
	"./de/page/SketchToXD.json": [
		83575,
		83575
	],
	"./de/page/VisioToFigjam.json": [
		41607,
		41607
	],
	"./de/page/XDToAI.json": [
		11454,
		11454
	],
	"./de/page/XDToFigma.json": [
		57511,
		57511
	],
	"./de/page/XDToPSD.json": [
		82301,
		82301
	],
	"./de/page/XDToSketch.json": [
		15510,
		15510
	],
	"./de/page/account.json": [
		15986,
		15986
	],
	"./de/page/airtable-backup.json": [
		90054,
		90054
	],
	"./de/page/converterFeatures.json": [
		79008,
		79008
	],
	"./de/page/enterprise.json": [
		79818,
		79818
	],
	"./de/page/figma-components-to-xd.json": [
		30514,
		30514
	],
	"./de/page/figma-design-backup.json": [
		11139,
		11139
	],
	"./de/page/filename.json": [
		57985,
		57985
	],
	"./de/page/files.json": [
		69664,
		69664
	],
	"./de/page/legal.json": [
		24784,
		24784
	],
	"./de/page/miro-backup.json": [
		27050,
		27050
	],
	"./de/page/open-xd-file-flinto.json": [
		89815,
		89815
	],
	"./de/page/open-xd-file-old-corrupted.json": [
		88932,
		88932
	],
	"./de/page/open-xd-file-principle.json": [
		46872,
		46872
	],
	"./de/page/open-xd-in-builderx.json": [
		80440,
		80440
	],
	"./de/page/open-xd-in-uxpin.json": [
		30038,
		30038
	],
	"./de/page/pricing.json": [
		43836,
		43836
	],
	"./de/page/privacy.json": [
		83222,
		83222
	],
	"./de/page/refundPolicy.json": [
		41043,
		41043
	],
	"./de/page/settings.json": [
		17621,
		17621
	],
	"./de/page/solutionsForAgencies.json": [
		92361,
		92361
	],
	"./de/page/solutionsForEnterprise.json": [
		93625,
		93625
	],
	"./de/page/terms.json": [
		58692,
		58692
	],
	"./de/payment.json": [
		2604,
		2604
	],
	"./de/section/airtableBackupFaq.json": [
		61954,
		61954
	],
	"./de/section/blog.json": [
		56945,
		56945
	],
	"./de/section/brokenXD.json": [
		71860,
		71860
	],
	"./de/section/colorfulCta.json": [
		71190,
		71190
	],
	"./de/section/conversion.json": [
		8536,
		8536
	],
	"./de/section/convertAllFormats.json": [
		81403,
		81403
	],
	"./de/section/convertEverything.json": [
		65439,
		65439
	],
	"./de/section/cta.json": [
		90772,
		90772
	],
	"./de/section/customersLogos.json": [
		29877,
		29877
	],
	"./de/section/description.json": [
		17870,
		17870
	],
	"./de/section/designEngine.json": [
		9421,
		9421
	],
	"./de/section/enterpriseSolutionsFaq.json": [
		20918,
		20918
	],
	"./de/section/faq.json": [
		10728,
		10728
	],
	"./de/section/features.json": [
		65138,
		65138
	],
	"./de/section/featuresSimple.json": [
		95263,
		95263
	],
	"./de/section/figmaBackupFaq.json": [
		64019,
		64019
	],
	"./de/section/getStartedVideo.json": [
		2202,
		2202
	],
	"./de/section/magicians.json": [
		947,
		947
	],
	"./de/section/newsletterSignup.json": [
		88150,
		88150
	],
	"./de/section/pricing.json": [
		70859,
		70859
	],
	"./de/section/pricingFigmaBackup.json": [
		21598,
		21598
	],
	"./de/section/requestDemo.json": [
		81983,
		81983
	],
	"./de/section/selectFormat.json": [
		77174,
		77174
	],
	"./de/section/testimonials.json": [
		44169,
		44169
	],
	"./de/section/trustedBy.json": [
		38096,
		38096
	],
	"./de/successfulPaymentModal.json": [
		45738,
		45738
	],
	"./de/welcomeAboardModal.json": [
		70852,
		70852
	],
	"./en/common.json": [
		83147,
		83147
	],
	"./en/converter.json": [
		90509,
		90509
	],
	"./en/downloadHelpArticleModal.json": [
		34475,
		34475
	],
	"./en/fileTypes.json": [
		26638,
		26638
	],
	"./en/footer.json": [
		9170,
		9170
	],
	"./en/freeTrialModal.json": [
		27407,
		27407
	],
	"./en/inquiryForm.json": [
		11531,
		11531
	],
	"./en/landingPage.json": [
		75416,
		75416
	],
	"./en/navigation.json": [
		65619,
		65619
	],
	"./en/page/AIToFigma.json": [
		95060,
		95060
	],
	"./en/page/AIToSketch.json": [
		53974,
		53974
	],
	"./en/page/CanvaToAI.json": [
		95900,
		95900
	],
	"./en/page/CanvaToFigma.json": [
		41705,
		41705
	],
	"./en/page/CanvaToGoogleslides.json": [
		81321,
		81321
	],
	"./en/page/CanvaToHTML.json": [
		17216,
		17216
	],
	"./en/page/CanvaToIndesign.json": [
		6530,
		6530
	],
	"./en/page/CanvaToPSD.json": [
		32084,
		32084
	],
	"./en/page/CanvaToPowerpoint.json": [
		99713,
		99713
	],
	"./en/page/CanvaToWordpress.json": [
		95356,
		95356
	],
	"./en/page/CanvaToXd.json": [
		99872,
		99872
	],
	"./en/page/EPSToFigma.json": [
		60576,
		60576
	],
	"./en/page/ExpressToCanva.json": [
		40347,
		40347
	],
	"./en/page/ExpressToFigma.json": [
		534,
		534
	],
	"./en/page/ExtractImagesFromXD.json": [
		55762,
		55762
	],
	"./en/page/FigjamToLucidChart.json": [
		63304,
		63304
	],
	"./en/page/FigjamToMiro.json": [
		24929,
		24929
	],
	"./en/page/FigmaToAI.json": [
		79989,
		79989
	],
	"./en/page/FigmaToAfterEffects.json": [
		22835,
		22835
	],
	"./en/page/FigmaToAxure.json": [
		71050,
		71050
	],
	"./en/page/FigmaToBubble.json": [
		74420,
		74420
	],
	"./en/page/FigmaToCanva.json": [
		80833,
		80833
	],
	"./en/page/FigmaToGoogleSlides.json": [
		94217,
		94217
	],
	"./en/page/FigmaToIndesign.json": [
		50651,
		50651
	],
	"./en/page/FigmaToPDF.json": [
		41552,
		41552
	],
	"./en/page/FigmaToPSD.json": [
		73002,
		73002
	],
	"./en/page/FigmaToPowerpoint.json": [
		34467,
		34467
	],
	"./en/page/FigmaToSketch.json": [
		39950,
		39950
	],
	"./en/page/FigmaToWebflow.json": [
		41699,
		41699
	],
	"./en/page/FigmaToXD.json": [
		88241,
		88241
	],
	"./en/page/FreehandToFigjam.json": [
		62034,
		62034
	],
	"./en/page/GoogleSlidesToCanva.json": [
		28584,
		28584
	],
	"./en/page/GoogleSlidesToFigma.json": [
		64364,
		64364
	],
	"./en/page/IndesignToFigma.json": [
		5004,
		57082
	],
	"./en/page/IndesignToSketch.json": [
		12902,
		12902
	],
	"./en/page/IndesignToXd.json": [
		71123,
		71123
	],
	"./en/page/Inspector.json": [
		49317,
		49317
	],
	"./en/page/KeynoteToFigma.json": [
		9323,
		9323
	],
	"./en/page/KeynoteToSketch.json": [
		84188,
		84188
	],
	"./en/page/KeynoteToXd.json": [
		87032,
		87032
	],
	"./en/page/LucidChartToFigjam.json": [
		87391,
		87391
	],
	"./en/page/LucidChartToMiro.json": [
		32838,
		32838
	],
	"./en/page/MiroToFigjam.json": [
		19428,
		19428
	],
	"./en/page/MiroToLucidChart.json": [
		60676,
		60676
	],
	"./en/page/MiroToMural.json": [
		51406,
		51406
	],
	"./en/page/MuralToMiro.json": [
		91720,
		91720
	],
	"./en/page/PDFToAI.json": [
		93886,
		93886
	],
	"./en/page/PDFToFigma.json": [
		71405,
		71405
	],
	"./en/page/PDFToIndesign.json": [
		23182,
		23182
	],
	"./en/page/PDFToPSD.json": [
		61658,
		61658
	],
	"./en/page/PDFToSketch.json": [
		20852,
		20852
	],
	"./en/page/PDFToXD.json": [
		42247,
		42247
	],
	"./en/page/PSDToCanva.json": [
		20177,
		20177
	],
	"./en/page/PSDToFigma.json": [
		76098,
		76098
	],
	"./en/page/PSDToSketch.json": [
		88726,
		88726
	],
	"./en/page/PowerPointToAi.json": [
		1699,
		1699
	],
	"./en/page/PowerPointToCanva.json": [
		407,
		407
	],
	"./en/page/PowerPointToFigma.json": [
		18836,
		18836
	],
	"./en/page/PowerPointToPsd.json": [
		756,
		756
	],
	"./en/page/PowerPointToSketch.json": [
		52312,
		52312
	],
	"./en/page/PowerPointToXd.json": [
		71986,
		71986
	],
	"./en/page/SketchToAI.json": [
		57056,
		57056
	],
	"./en/page/SketchToFigma.json": [
		87120,
		87120
	],
	"./en/page/SketchToPSD.json": [
		78926,
		78926
	],
	"./en/page/SketchToXD.json": [
		16852,
		16852
	],
	"./en/page/VisioToFigjam.json": [
		20144,
		20144
	],
	"./en/page/WebsiteToFigma.json": [
		77032,
		77032
	],
	"./en/page/XDToAI.json": [
		67539,
		67539
	],
	"./en/page/XDToCanva.json": [
		45195,
		45195
	],
	"./en/page/XDToFigma.json": [
		14370,
		14370
	],
	"./en/page/XDToJPG.json": [
		45265,
		45265
	],
	"./en/page/XDToPDF.json": [
		7389,
		7389
	],
	"./en/page/XDToPSD.json": [
		9680,
		9680
	],
	"./en/page/XDToPowerpoint.json": [
		38721,
		38721
	],
	"./en/page/XDToSketch.json": [
		41924,
		41924
	],
	"./en/page/account.json": [
		19161,
		19161
	],
	"./en/page/airtable-backup.json": [
		83236,
		83236
	],
	"./en/page/canvaAuth.json": [
		79423,
		79423
	],
	"./en/page/converterFeatures.json": [
		15411,
		15411
	],
	"./en/page/enterprise.json": [
		26333,
		26333
	],
	"./en/page/figma-components-to-xd.json": [
		33358,
		33358
	],
	"./en/page/figma-design-backup.json": [
		3380,
		3380
	],
	"./en/page/filename.json": [
		77489,
		77489
	],
	"./en/page/files.json": [
		52447,
		52447
	],
	"./en/page/import-figma-in-canva.json": [
		84628,
		84628
	],
	"./en/page/legal.json": [
		79046,
		79046
	],
	"./en/page/miro-backup.json": [
		6455,
		6455
	],
	"./en/page/open-xd-file-flinto.json": [
		31250,
		31250
	],
	"./en/page/open-xd-file-old-corrupted.json": [
		60455,
		60455
	],
	"./en/page/open-xd-file-principle.json": [
		38044,
		38044
	],
	"./en/page/open-xd-in-builderx.json": [
		29545,
		29545
	],
	"./en/page/open-xd-in-uxpin.json": [
		23980,
		23980
	],
	"./en/page/pricing.json": [
		44726,
		44726
	],
	"./en/page/privacy.json": [
		87185,
		87185
	],
	"./en/page/refundPolicy.json": [
		28387,
		28387
	],
	"./en/page/settings.json": [
		73302,
		73302
	],
	"./en/page/solutionsForAgencies.json": [
		72008,
		72008
	],
	"./en/page/solutionsForEnterprise.json": [
		42434,
		42434
	],
	"./en/page/terms.json": [
		25091,
		25091
	],
	"./en/page/xd-components-to-figma.json": [
		44590,
		44590
	],
	"./en/payment.json": [
		6132,
		6132
	],
	"./en/section/airtableBackupFaq.json": [
		85094,
		85094
	],
	"./en/section/blog.json": [
		96112,
		96112
	],
	"./en/section/brokenXD.json": [
		23021,
		23021
	],
	"./en/section/colorfulCta.json": [
		39658,
		39658
	],
	"./en/section/contact.json": [
		23384,
		23384
	],
	"./en/section/conversion.json": [
		94808,
		94808
	],
	"./en/section/convertAllFormats.json": [
		43626,
		43626
	],
	"./en/section/convertEverything.json": [
		64929,
		64929
	],
	"./en/section/cta.json": [
		11380,
		11380
	],
	"./en/section/customersLogos.json": [
		15983,
		15983
	],
	"./en/section/description.json": [
		32429,
		32429
	],
	"./en/section/designEngine.json": [
		99087,
		99087
	],
	"./en/section/enterpriseSolutionsFaq.json": [
		87960,
		87960
	],
	"./en/section/faq.json": [
		68532,
		68532
	],
	"./en/section/features.json": [
		95070,
		95070
	],
	"./en/section/featuresSimple.json": [
		6948,
		6948
	],
	"./en/section/figmaBackupFaq.json": [
		13323,
		13323
	],
	"./en/section/getStartedVideo.json": [
		8193,
		8193
	],
	"./en/section/magicians.json": [
		24691,
		24691
	],
	"./en/section/newsletterSignup.json": [
		24657,
		24657
	],
	"./en/section/pricing.json": [
		71572,
		71572
	],
	"./en/section/pricingFigmaBackup.json": [
		63246,
		63246
	],
	"./en/section/requestDemo.json": [
		93955,
		93955
	],
	"./en/section/selectFormat.json": [
		88681,
		88681
	],
	"./en/section/testimonials.json": [
		88610,
		88610
	],
	"./en/section/trustedBy.json": [
		53638,
		53638
	],
	"./en/successfulPaymentModal.json": [
		67475,
		67475
	],
	"./en/welcomeAboardModal.json": [
		88076,
		88076
	],
	"./es/common.json": [
		44501,
		44501
	],
	"./es/converter.json": [
		1796,
		1796
	],
	"./es/fileTypes.json": [
		29267,
		29267
	],
	"./es/footer.json": [
		38980,
		38980
	],
	"./es/landingPage.json": [
		82112,
		82112
	],
	"./es/navigation.json": [
		4815,
		4815
	],
	"./es/page/AIToFigma.json": [
		46052,
		46052
	],
	"./es/page/AIToSketch.json": [
		64681,
		64681
	],
	"./es/page/CanvaToFigma.json": [
		97551,
		97551
	],
	"./es/page/FigmaToAI.json": [
		8076,
		8076
	],
	"./es/page/FigmaToGoogleSlides.json": [
		20501,
		20501
	],
	"./es/page/FigmaToPSD.json": [
		1650,
		1650
	],
	"./es/page/FigmaToSketch.json": [
		5667,
		5667
	],
	"./es/page/FigmaToXD.json": [
		72236,
		72236
	],
	"./es/page/GoogleSlidesToFigma.json": [
		33538,
		33538
	],
	"./es/page/IndesignToFigma.json": [
		77752,
		77752
	],
	"./es/page/PDFToFigma.json": [
		18070,
		18070
	],
	"./es/page/PDFToPSD.json": [
		65531,
		65531
	],
	"./es/page/PDFToSketch.json": [
		71125,
		71125
	],
	"./es/page/PDFToXD.json": [
		20393,
		20393
	],
	"./es/page/PSDToFigma.json": [
		12834,
		12834
	],
	"./es/page/PSDToSketch.json": [
		68401,
		68401
	],
	"./es/page/SketchToAI.json": [
		62797,
		62797
	],
	"./es/page/SketchToFigma.json": [
		58475,
		58475
	],
	"./es/page/SketchToPSD.json": [
		89444,
		89444
	],
	"./es/page/SketchToXD.json": [
		82339,
		82339
	],
	"./es/page/VisioToFigjam.json": [
		81430,
		81430
	],
	"./es/page/XDToAI.json": [
		3602,
		3602
	],
	"./es/page/XDToFigma.json": [
		94010,
		94010
	],
	"./es/page/XDToPSD.json": [
		47823,
		47823
	],
	"./es/page/XDToSketch.json": [
		79570,
		79570
	],
	"./es/page/airtable-backup.json": [
		38007,
		38007
	],
	"./es/page/converterFeatures.json": [
		58472,
		58472
	],
	"./es/page/enterprise.json": [
		33126,
		33126
	],
	"./es/page/figma-design-backup.json": [
		63399,
		63399
	],
	"./es/page/files.json": [
		17331,
		17331
	],
	"./es/page/miro-backup.json": [
		33447,
		33447
	],
	"./es/page/pricing.json": [
		10665,
		10665
	],
	"./es/payment.json": [
		90917,
		90917
	],
	"./es/section/airtableBackupFaq.json": [
		50112,
		50112
	],
	"./es/section/blog.json": [
		43419,
		43419
	],
	"./es/section/colorfulCta.json": [
		47075,
		47075
	],
	"./es/section/conversion.json": [
		13961,
		13961
	],
	"./es/section/convertAllFormats.json": [
		80889,
		80889
	],
	"./es/section/convertEverything.json": [
		94989,
		94989
	],
	"./es/section/cta.json": [
		56405,
		56405
	],
	"./es/section/customersLogos.json": [
		11661,
		11661
	],
	"./es/section/designEngine.json": [
		9299,
		9299
	],
	"./es/section/faq.json": [
		43248,
		43248
	],
	"./es/section/features.json": [
		61220,
		61220
	],
	"./es/section/featuresSimple.json": [
		61776,
		61776
	],
	"./es/section/magicians.json": [
		33930,
		33930
	],
	"./es/section/pricing.json": [
		65088,
		65088
	],
	"./es/section/requestDemo.json": [
		43100,
		43100
	],
	"./es/section/testimonials.json": [
		32710,
		32710
	],
	"./es/section/trustedBy.json": [
		79962,
		79962
	],
	"./es/welcomeAboardModal.json": [
		98989,
		98989
	],
	"./fr/common.json": [
		97038,
		97038
	],
	"./fr/converter.json": [
		69302,
		69302
	],
	"./fr/downloadHelpArticleModal.json": [
		76605,
		76605
	],
	"./fr/fileTypes.json": [
		91924,
		91924
	],
	"./fr/footer.json": [
		56276,
		56276
	],
	"./fr/freeTrialModal.json": [
		49757,
		89026
	],
	"./fr/inquiryForm.json": [
		11844,
		11844
	],
	"./fr/landingPage.json": [
		74646,
		74646
	],
	"./fr/navigation.json": [
		68549,
		68549
	],
	"./fr/page/AIToFigma.json": [
		13830,
		13830
	],
	"./fr/page/AIToSketch.json": [
		90359,
		90359
	],
	"./fr/page/CanvaToFigma.json": [
		72816,
		72816
	],
	"./fr/page/EPSToFigma.json": [
		98096,
		98096
	],
	"./fr/page/FigmaToAI.json": [
		57826,
		57826
	],
	"./fr/page/FigmaToCanva.json": [
		61367,
		61367
	],
	"./fr/page/FigmaToGoogleSlides.json": [
		90650,
		90650
	],
	"./fr/page/FigmaToPSD.json": [
		73087,
		73087
	],
	"./fr/page/FigmaToPowerpoint.json": [
		75068,
		75068
	],
	"./fr/page/FigmaToSketch.json": [
		34013,
		34013
	],
	"./fr/page/FigmaToXD.json": [
		70143,
		70143
	],
	"./fr/page/GoogleSlidesToFigma.json": [
		94562,
		94562
	],
	"./fr/page/IndesignToFigma.json": [
		7736,
		7736
	],
	"./fr/page/PDFToFigma.json": [
		47289,
		47289
	],
	"./fr/page/PDFToPSD.json": [
		20118,
		20118
	],
	"./fr/page/PDFToSketch.json": [
		89077,
		89077
	],
	"./fr/page/PDFToXD.json": [
		46884,
		46884
	],
	"./fr/page/PSDToFigma.json": [
		54599,
		54599
	],
	"./fr/page/PSDToSketch.json": [
		13265,
		13265
	],
	"./fr/page/SketchToAI.json": [
		84849,
		84849
	],
	"./fr/page/SketchToFigma.json": [
		77427,
		77427
	],
	"./fr/page/SketchToPSD.json": [
		86077,
		86077
	],
	"./fr/page/SketchToXD.json": [
		30475,
		30475
	],
	"./fr/page/VisioToFigjam.json": [
		85941,
		85941
	],
	"./fr/page/XDToAI.json": [
		20560,
		20560
	],
	"./fr/page/XDToFigma.json": [
		3785,
		3785
	],
	"./fr/page/XDToPSD.json": [
		9060,
		9060
	],
	"./fr/page/XDToSketch.json": [
		2549,
		2549
	],
	"./fr/page/account.json": [
		87515,
		87515
	],
	"./fr/page/airtable-backup.json": [
		73045,
		73045
	],
	"./fr/page/converterFeatures.json": [
		31653,
		31653
	],
	"./fr/page/enterprise.json": [
		31588,
		31588
	],
	"./fr/page/figma-components-to-xd.json": [
		84265,
		84265
	],
	"./fr/page/figma-design-backup.json": [
		61836,
		61836
	],
	"./fr/page/filename.json": [
		6487,
		6487
	],
	"./fr/page/files.json": [
		54921,
		54921
	],
	"./fr/page/legal.json": [
		89779,
		89779
	],
	"./fr/page/miro-backup.json": [
		5042,
		5042
	],
	"./fr/page/open-xd-file-flinto.json": [
		74354,
		74354
	],
	"./fr/page/open-xd-file-old-corrupted.json": [
		90954,
		90954
	],
	"./fr/page/open-xd-file-principle.json": [
		5133,
		5133
	],
	"./fr/page/open-xd-in-builderx.json": [
		68185,
		68185
	],
	"./fr/page/open-xd-in-uxpin.json": [
		91338,
		91338
	],
	"./fr/page/pricing.json": [
		54618,
		54618
	],
	"./fr/page/privacy.json": [
		52891,
		52891
	],
	"./fr/page/refundPolicy.json": [
		64456,
		64456
	],
	"./fr/page/settings.json": [
		83177,
		83177
	],
	"./fr/page/solutionsForAgencies.json": [
		52220,
		52220
	],
	"./fr/page/solutionsForEnterprise.json": [
		61393,
		61393
	],
	"./fr/page/terms.json": [
		58762,
		58762
	],
	"./fr/payment.json": [
		80547,
		80547
	],
	"./fr/section/airtableBackupFaq.json": [
		23185,
		23185
	],
	"./fr/section/blog.json": [
		10579,
		10579
	],
	"./fr/section/brokenXD.json": [
		5344,
		5344
	],
	"./fr/section/colorfulCta.json": [
		83641,
		83641
	],
	"./fr/section/conversion.json": [
		24726,
		24726
	],
	"./fr/section/convertAllFormats.json": [
		14827,
		14827
	],
	"./fr/section/convertEverything.json": [
		85991,
		85991
	],
	"./fr/section/cta.json": [
		7728,
		7728
	],
	"./fr/section/customersLogos.json": [
		9205,
		9205
	],
	"./fr/section/description.json": [
		47084,
		47084
	],
	"./fr/section/designEngine.json": [
		69691,
		69691
	],
	"./fr/section/faq.json": [
		36920,
		36920
	],
	"./fr/section/features.json": [
		8206,
		8206
	],
	"./fr/section/featuresSimple.json": [
		63190,
		63190
	],
	"./fr/section/figmaBackupFaq.json": [
		57836,
		57836
	],
	"./fr/section/getStartedVideo.json": [
		20562,
		20562
	],
	"./fr/section/magicians.json": [
		914,
		914
	],
	"./fr/section/newsletterSignup.json": [
		11743,
		11743
	],
	"./fr/section/pricing.json": [
		44166,
		44166
	],
	"./fr/section/pricingFigmaBackup.json": [
		86903,
		86903
	],
	"./fr/section/requestDemo.json": [
		46620,
		46620
	],
	"./fr/section/selectFormat.json": [
		85653,
		85653
	],
	"./fr/section/testimonials.json": [
		59078,
		59078
	],
	"./fr/section/trustedBy.json": [
		2341,
		2341
	],
	"./fr/successfulPaymentModal.json": [
		39227,
		39227
	],
	"./fr/welcomeAboardModal.json": [
		55080,
		55080
	],
	"./zh/common.json": [
		60072,
		60072
	],
	"./zh/converter.json": [
		29642,
		29642
	],
	"./zh/downloadHelpArticleModal.json": [
		76409,
		76409
	],
	"./zh/fileTypes.json": [
		20811,
		20811
	],
	"./zh/footer.json": [
		47154,
		47154
	],
	"./zh/inquiryForm.json": [
		27872,
		27872
	],
	"./zh/landingPage.json": [
		64196,
		64196
	],
	"./zh/navigation.json": [
		2568,
		2568
	],
	"./zh/page/AIToFigma.json": [
		47013,
		47013
	],
	"./zh/page/AIToSketch.json": [
		99905,
		99905
	],
	"./zh/page/CanvaToFigma.json": [
		55148,
		55148
	],
	"./zh/page/EPSToFigma.json": [
		12245,
		12245
	],
	"./zh/page/FigmaToAI.json": [
		33470,
		33470
	],
	"./zh/page/FigmaToCanva.json": [
		81237,
		81237
	],
	"./zh/page/FigmaToGoogleSlides.json": [
		62256,
		62256
	],
	"./zh/page/FigmaToPSD.json": [
		50741,
		50741
	],
	"./zh/page/FigmaToPowerpoint.json": [
		38047,
		38047
	],
	"./zh/page/FigmaToSketch.json": [
		13257,
		13257
	],
	"./zh/page/FigmaToXD.json": [
		21409,
		21409
	],
	"./zh/page/GoogleSlidesToFigma.json": [
		54084,
		54084
	],
	"./zh/page/IndesignToFigma.json": [
		99730,
		99730
	],
	"./zh/page/PDFToFigma.json": [
		7030,
		7030
	],
	"./zh/page/PDFToPSD.json": [
		74759,
		74759
	],
	"./zh/page/PDFToSketch.json": [
		12990,
		12990
	],
	"./zh/page/PDFToXD.json": [
		4963,
		4963
	],
	"./zh/page/PSDToFigma.json": [
		34941,
		75878
	],
	"./zh/page/PSDToSketch.json": [
		78443,
		78443
	],
	"./zh/page/SketchToAI.json": [
		9836,
		9836
	],
	"./zh/page/SketchToFigma.json": [
		6630,
		6630
	],
	"./zh/page/SketchToPSD.json": [
		8980,
		8980
	],
	"./zh/page/SketchToXD.json": [
		47004,
		47004
	],
	"./zh/page/VisioToFigjam.json": [
		73524,
		73524
	],
	"./zh/page/XDToAI.json": [
		35669,
		35669
	],
	"./zh/page/XDToFigma.json": [
		92771,
		92771
	],
	"./zh/page/XDToPSD.json": [
		42254,
		42254
	],
	"./zh/page/XDToSketch.json": [
		5808,
		5808
	],
	"./zh/page/account.json": [
		13365,
		13365
	],
	"./zh/page/airtable-backup.json": [
		87843,
		87843
	],
	"./zh/page/converterFeatures.json": [
		68368,
		68368
	],
	"./zh/page/enterprise.json": [
		2313,
		2313
	],
	"./zh/page/figma-components-to-xd.json": [
		94757,
		94757
	],
	"./zh/page/figma-design-backup.json": [
		18904,
		18904
	],
	"./zh/page/filename.json": [
		36959,
		36959
	],
	"./zh/page/files.json": [
		58353,
		58353
	],
	"./zh/page/legal.json": [
		98088,
		98088
	],
	"./zh/page/miro-backup.json": [
		19262,
		19262
	],
	"./zh/page/open-xd-file-flinto.json": [
		22677,
		22677
	],
	"./zh/page/open-xd-file-old-corrupted.json": [
		44347,
		44347
	],
	"./zh/page/open-xd-file-principle.json": [
		52429,
		52429
	],
	"./zh/page/open-xd-in-builderx.json": [
		90578,
		90578
	],
	"./zh/page/open-xd-in-uxpin.json": [
		22611,
		60946
	],
	"./zh/page/pricing.json": [
		42873,
		42873
	],
	"./zh/page/privacy.json": [
		47624,
		47624
	],
	"./zh/page/refundPolicy.json": [
		71868,
		71868
	],
	"./zh/page/settings.json": [
		27902,
		27902
	],
	"./zh/page/solutionsForAgencies.json": [
		66339,
		66339
	],
	"./zh/page/terms.json": [
		61118,
		61118
	],
	"./zh/payment.json": [
		36735,
		36735
	],
	"./zh/section/airtableBackupFaq.json": [
		35696,
		35696
	],
	"./zh/section/blog.json": [
		54273,
		54273
	],
	"./zh/section/brokenXD.json": [
		25423,
		25423
	],
	"./zh/section/colorfulCta.json": [
		84025,
		84025
	],
	"./zh/section/conversion.json": [
		98506,
		98506
	],
	"./zh/section/convertAllFormats.json": [
		87991,
		87991
	],
	"./zh/section/convertEverything.json": [
		2730,
		2730
	],
	"./zh/section/cta.json": [
		76236,
		76236
	],
	"./zh/section/customersLogos.json": [
		48724,
		48724
	],
	"./zh/section/description.json": [
		78482,
		78482
	],
	"./zh/section/designEngine.json": [
		88747,
		88747
	],
	"./zh/section/faq.json": [
		91248,
		36159
	],
	"./zh/section/features.json": [
		99363,
		99363
	],
	"./zh/section/featuresSimple.json": [
		53520,
		53520
	],
	"./zh/section/figmaBackupFaq.json": [
		87067,
		87067
	],
	"./zh/section/getStartedVideo.json": [
		3866,
		3866
	],
	"./zh/section/magicians.json": [
		1582,
		1582
	],
	"./zh/section/newsletterSignup.json": [
		12789,
		12789
	],
	"./zh/section/pricing.json": [
		56676,
		56676
	],
	"./zh/section/pricingFigmaBackup.json": [
		38410,
		38410
	],
	"./zh/section/requestDemo.json": [
		59365,
		59365
	],
	"./zh/section/selectFormat.json": [
		19903,
		19903
	],
	"./zh/section/testimonials.json": [
		99438,
		99438
	],
	"./zh/section/trustedBy.json": [
		33359,
		33359
	],
	"./zh/successfulPaymentModal.json": [
		49501,
		49501
	],
	"./zh/welcomeAboardModal.json": [
		5610,
		5610
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7535;
module.exports = webpackAsyncContext;